import React, {useMemo, useState} from "react";
import {GetStatusType, ProductByCategoryType} from "@/lib/type/product-center";
import {Button, Pagination} from "antd";
import Image from "next/image";
import {Placeholder} from "@/components/placeholder";
import Link from "next/link";
import {getProductDetailLink} from "@/lib/util/get-router";

type Props = {
    products?:ProductByCategoryType
    currentPage?:number
    pageSize?:number
    pageChange?:(current:number,size:number)=>void
}
const ProductList:React.FC<Props> = ({products,currentPage,pageSize,pageChange}) => {
    // 总条数
    const total = useMemo(() => {
        if(products?.pages.totalCount){
            return parseInt(products?.pages.totalCount)
        }
    }, [products]);
    
    // 产品的排布方式 true为表格 false为grid
    const [permutationWays, setPermutationWays] = useState(true)

    // 每页可以显示多少条
    const pageSizeOptions = [5]

    return <div>
        <div className='bg-white'>
            <div className='bg-[#fef3f1] p-4 b-flex'>
                <span className='text-main text-xl'>产品列表</span>
                <div className='flex text-gray-500'>
                    <p className='p-2 bg-white border'>
                        共 <span className='text-main'>{total}</span> 条
                    </p>
                    <p className={`p-2 border cursor-pointer hover:bg-main hover:text-white duration-300 ${permutationWays ? 'bg-main text-white' : 'bg-white text-black'}`}
                       onClick={()=>setPermutationWays(true)}
                    >
                        <i className="ri-play-list-add-line mr-2"></i>
                        <span>列表</span>
                    </p>
                    <p className={`p-2 border cursor-pointer hover:bg-main hover:text-white duration-300 ${!permutationWays ? 'bg-main text-white' : 'bg-white text-black'}`}
                       onClick={()=>setPermutationWays(false)}
                    >
                        <i className="ri-list-radio"></i>
                        <span>列表</span>
                    </p>
                    <div className='p-2 bg-white border'>
                            <Pagination
                                simple
                                total={total}
                                current={currentPage}
                                onChange={pageChange}
                                showSizeChanger={false}
                            />
                    </div>
                </div>
            </div>

            {
                permutationWays ? <div>
                    <div className='grid grid-cols-9 border border-t py-4'>
                        <div className='text-center'>商品图片</div>
                        <div className='col-span-2 text-center'>商品名称</div>
                        <div className='col-span-4 text-center'>产品属性</div>
                        <div className='col-span-2 text-center'>操作</div>
                    </div>
                    {
                        products?.list.map(item => {
                            return <Link key={item.id} href={getProductDetailLink(item.slug)}>
                                <div className='grid grid-cols-9 py-4 border border-t text-black hover:bg-[#fef3f1]  group'>
                                    <div className='c-flex'>
                                        <Placeholder src={item.picture || '/default.png'} alt='加载中' imageWidth={100}
                                                     imageHeight={100}></Placeholder>
                                    </div>
                                    <div className='col-span-2 group-hover:text-main font-black flex flex-col justify-between'>
                                        <span>{item.name}</span>
                                        <p className='px-2 py-1 bg-[#fef3f1] hover:bg-main hover:text-white duration-300 w-fit group'>
                                            <i className="ri-projector-2-line mr-2 "></i>
                                            <span className='text-gray-500 hover:text-white'>预览文档</span>
                                        </p>
                                    </div>
                                    <div className='col-span-4 bg-[#f9f9f9] rounded-xl grid grid-cols-3 gap-5 p-2'>
                                        {item.attributeValue?.map((attItem,attIndex)=>{
                                             return <p key={attIndex} className='text-[#666]'>
                                                <span>{attItem.title}：{attItem.data}</span>
                                            </p>
                                        })}
                                    </div>
                                    <div className='col-span-2 c-flex flex-col'>
                                        <Button className='w-20 !border-main !text-main'>PDF下载</Button>
                                        <Button className='w-20 mt-2 !border-main !text-main'>去购买</Button>
                                    </div>
                                </div>
                            </Link>
                        })
                    }
                </div> : <div className='grid grid-cols-5 gap-5 bg-[#f5f7fa]'>
                    {
                        products?.list.map(item=>{
                            return <Link href={getProductDetailLink(item.slug)} key={item.id}>
                                <div className='bg-white c-flex flex-col text-black pb-4 group'>
                                    <div className='overflow-hidden'>
                                        <Placeholder src={item.picture || '/default.png'} alt='加载中' imageWidth={250}
                                                     imageHeight={250} className='hover:scale-105 duration-300'></Placeholder>
                                    </div>
                                    <p className='line-clamp-2 font-black my-4 group-hover:text-main'>{item.name}</p>
                                    <div className='c-flex'>
                                        <p className='px-2 py-1 border hover:bg-main hover:text-white duration-300'>
                                            <i className="ri-projector-2-line mr-2 "></i>
                                            <span>预览文档</span>
                                        </p>
                                        <p className='px-2 py-1 border ml-2 hover:bg-main hover:text-white duration-300'>
                                            <i className="ri-file-pdf-2-line"></i>
                                            <span>PDF下载</span>
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        })
                    }
                </div>
            }


        </div>

        <div className='c-flex bg-transparent py-4'>
            <Pagination
                total={total}
                showSizeChanger={false}
                showQuickJumper
                pageSize={pageSize}
                pageSizeOptions={pageSizeOptions}
                current={currentPage}
                // hideOnSinglePage={true}
                showTotal={(total) => <p>共 <span className='text-main'>{total}</span> 条</p>}
                onChange={pageChange}

            />
        </div>
    </div>
}

export default ProductList